import { RouteInput, RouteSlotInput, TeamPage } from '@luks/ui';
import { ComponentProps } from 'react';

import { cleanList } from '../../commons/cleanList';
import { helpfulness } from '../../commons/Helpfulness';
import { SEO } from '../../commons/Seo';
import mapPageMetadata from '../../commons/useMetatags';
import { mapParagraphs } from '../paragraphs/AllParagraphs';
import { mapSpacer } from '../paragraphs/Spacer';
import { mapSpecialistSlider } from '../paragraphs/SpecialistSlider';
import { mapSidebar } from '../Sidebar';
import { mapBasicPageHeader } from './BasicPage';

function mapTeamPageBody(
  input: TeamPageFragment,
): Array<RouteSlotInput<typeof TeamPage, 'body'>> {
  const body: Array<RouteSlotInput<typeof TeamPage, 'body'>> = [];
  if (input.body?.length) {
    body.push(...mapParagraphs(input.body.filter(cleanList)));
  }
  if (input.contentBottom?.length) {
    // This is not a mistake. Paragraph bottom should go after the body.
    body.push(
      mapSpacer({
        desktopOnly: false,
        withoutBorder: false,
        __typename: 'ParagraphSpacer',
      }),
      ...mapParagraphs(input.contentBottom.filter(cleanList)),
    );
  }
  if (input.specialists?.length) {
    body.push(
      mapSpacer({
        desktopOnly: false,
        withoutBorder: false,
        __typename: 'ParagraphSpacer',
      }),
      mapSpecialistSlider({
        title: input.specialistsTitle || 'Behandlungsteam',
        specialists: input.specialists,
        __typename: 'ParagraphSpecialistsSlider',
      }),
    );
  }
  if (input.contentSidebar?.length) {
    body.push(mapSidebar(input.contentSidebar));
  }
  body.push(helpfulness());
  return body;
}

export function mapTeamPage(
  input: TeamPageFragment,
): RouteInput<typeof TeamPage> {
  return {
    header: mapBasicPageHeader(input),
    body: mapTeamPageBody(input),
  };
}

export function mapTeamPageMetadata(
  input: TeamPageFragment,
): ComponentProps<typeof SEO> {
  return mapPageMetadata(input);
}
